// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"1049d5cf","225":"05d8fde8","344":"f28ea3b3","372":"83a42dd0","448":"36af9e1a","738":"6013f86a","787":"945ea02b","841":"ed50e909","856":"afc5528b"}[chunkId] + ".chunk.js";
};